import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { MapLocationDotIcon } from '@gemini/icons';
import { getAgencyProximity } from '@shared-utils/helpers/cardDisplay';
const Address = ({ zipCode, city, distance, isGreyContent = false, t }) => {
    let proximity;
    if (distance) {
        proximity = getAgencyProximity(distance);
    }
    return (_jsxs(Box, { display: "flex", flexWrap: "wrap", children: [_jsxs(Box, { display: "flex", children: [_jsx(MapLocationDotIcon, { marginRight: "spacing.8", size: "sizing.16" }), _jsxs(Box, { typography: "typography.body.14.regular", color: isGreyContent
                            ? 'color.content.light.default'
                            : 'color.content.default.default', children: [zipCode, " ", city] })] }), proximity && (_jsxs(Box, { marginLeft: "spacing.4", typography: "typography.body.14.regular", color: isGreyContent
                    ? 'color.content.light.default'
                    : 'color.content.default.default', children: ["\u00B7 ", t('wlac_proximity', { replace: { proximity: proximity } })] }))] }));
};
export default Address;
